import * as actionTypes from "./ActionTypes";
import { DB_COLLECTION } from "../../Constant/Constant";
import { db } from "../../Helper/Firebase";
import { addDoc, collection } from "firebase/firestore";

export const appointmentSuccess = (appointmentData) => {
  console.log(appointmentData);
  return {
    type: actionTypes.APPOINTMENT_SUCCESSFUL,
    payload: appointmentData,
  };
};

export const appointmentFail = () => {
  return {
    type: actionTypes.APPOINTMENT_FAIL,
  };
};

export const Appointment = (appointmentData) => {
  return (dispatch) => {
    addDoc(collection(db, DB_COLLECTION.APPOINTMENT), appointmentData)
      .then((res) => {
        appointmentSuccess(appointmentData);
        dispatch(appointmentSuccess(appointmentData));
      })
      .catch((err) => {
        dispatch(appointmentFail(err));
      });
  };
};
